export const getLSObject = (key: string, isString?: string) => {
  let data = localStorage.getItem(key);
  if (isString) return data;
  const _data = data ? JSON.parse(data) : data;
  return _data;
};
